var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabPrivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 30,
    viewBox: "0 0 27 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 9C4.5 6.61305 5.44821 4.32387 7.13604 2.63604C8.82387 0.948211 11.1131 0 13.5 0C15.8869 0 18.1761 0.948211 19.864 2.63604C21.5518 4.32387 22.5 6.61305 22.5 9H24C24.7956 9 25.5587 9.31607 26.1213 9.87868C26.6839 10.4413 27 11.2044 27 12V27C27 27.7956 26.6839 28.5587 26.1213 29.1213C25.5587 29.6839 24.7956 30 24 30H3C2.20435 30 1.44129 29.6839 0.87868 29.1213C0.31607 28.5587 0 27.7956 0 27V12C0 11.2044 0.31607 10.4413 0.87868 9.87868C1.44129 9.31607 2.20435 9 3 9H4.5ZM13.5 3C15.0913 3 16.6174 3.63214 17.7426 4.75736C18.8679 5.88258 19.5 7.4087 19.5 9H7.5C7.5 7.4087 8.13214 5.88258 9.25736 4.75736C10.3826 3.63214 11.9087 3 13.5 3ZM16.5 18C16.5 18.5266 16.3614 19.0439 16.0981 19.5C15.8348 19.956 15.456 20.3347 15 20.598V22.5C15 22.8978 14.842 23.2794 14.5607 23.5607C14.2794 23.842 13.8978 24 13.5 24C13.1022 24 12.7206 23.842 12.4393 23.5607C12.158 23.2794 12 22.8978 12 22.5V20.598C11.4281 20.2678 10.9812 19.7581 10.7285 19.148C10.4758 18.5379 10.4314 17.8614 10.6024 17.2235C10.7733 16.5857 11.1499 16.022 11.6738 15.62C12.1977 15.218 12.8396 15 13.5 15C14.2956 15 15.0587 15.3161 15.6213 15.8787C16.1839 16.4413 16.5 17.2044 16.5 18Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabPrivate);
export default __webpack_public_path__ + "static/media/tabPrivate.43621b46f005b063f9af390a252de11e.svg";
export { ForwardRef as ReactComponent };